var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.1C11.132 5.1 10.2996 5.45821 9.68583 6.09584C9.07208 6.73346 8.72727 7.59826 8.72727 8.5C8.72727 9.40174 9.07208 10.2665 9.68583 10.9042C10.2996 11.5418 11.132 11.9 12 11.9C12.868 11.9 13.7004 11.5418 14.3142 10.9042C14.9279 10.2665 15.2727 9.40174 15.2727 8.5C15.2727 7.59826 14.9279 6.73346 14.3142 6.09584C13.7004 5.45821 12.868 5.1 12 5.1ZM12 14.1667C10.5534 14.1667 9.16598 13.5696 8.14305 12.5069C7.12013 11.4442 6.54545 10.0029 6.54545 8.5C6.54545 6.99711 7.12013 5.55577 8.14305 4.49306C9.16598 3.43036 10.5534 2.83333 12 2.83333C13.4466 2.83333 14.834 3.43036 15.8569 4.49306C16.8799 5.55577 17.4545 6.99711 17.4545 8.5C17.4545 10.0029 16.8799 11.4442 15.8569 12.5069C14.834 13.5696 13.4466 14.1667 12 14.1667ZM12 0C6.54545 0 1.88727 3.52467 0 8.5C1.88727 13.4753 6.54545 17 12 17C17.4545 17 22.1127 13.4753 24 8.5C22.1127 3.52467 17.4545 0 12 0Z",
    fill: "#93A3D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPass);
export default __webpack_public_path__ + "static/media/viewPass.70bbd106dda61916babee0c04c5e38fb.svg";
export { ForwardRef as ReactComponent };